import styled from 'styled-components'
import { Spacing, Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { ScoreMark } from '../../types'
import { ReviewSection } from '../../styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 100%;

  > *:last-child {
    flex: 1 1 100%;
  }
`

export const ReviewSectionScore = styled(ReviewSection)`
  gap: ${Spacing.XS};
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SectionTitle = styled.div`
  ${Typography.Body};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const SectionContent = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};

  ul,
  ol {
    margin: 0;
    padding-inline-start: 20px;

    ul {
      padding-inline-start: 0;
      list-style-type: disc;
    }
  }

  li::marker {
    color: ${Colors.Neutral30};
  }

  b {
    font-weight: unset;
  }

  mark {
    font-weight: unset;
    background-color: unset;
    color: unset;
  }

  i {
    font-style: unset;
  }
`

export const ScoreMarkHeadline = styled.div<{ $mark: ScoreMark }>`
  ${Typography.Subhead};
  ${FontWeights.Medium};
  display: flex;
  align-items: center;
  gap: ${Spacing['3XS']};

  color: ${({ $mark }) => {
    switch ($mark) {
      case 'excellent':
        return Colors.Green50
      case 'good':
        return Colors.Amber40
      case 'weak':
        return Colors.Orange50
      case 'needs_work':
        return Colors.Red50
      default:
        return Colors.Red50
    }
  }};
`

export const ScoreMarkDescription = styled.div`
  color: ${Colors.Neutral50};
`
